var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner position-absolute"},[_c('div',{staticClass:"bounce1 mr-2",style:({width: _vm.size + 'px', height: _vm.size + 'px'})}),_c('div',{staticClass:"bounce2 mr-2",style:({width: _vm.size + 'px', height: _vm.size + 'px'})}),_c('div',{staticClass:"bounce3 mr-2",style:({width: _vm.size + 'px', height: _vm.size + 'px'})})])
}]

export { render, staticRenderFns }